import { DatePipe } from "@angular/common";
import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
} from "@angular/core";
import { FormControl } from "@angular/forms";
import { Store } from "@ngrx/store";
import { ToasterService } from "angular2-toaster";
import * as _ from "lodash";
// import { BsModalRef } from "ngx-bootstrap/modal/modal-options.class";
import "rxjs/add/operator/map";
import "rxjs/add/operator/startWith";
import swal from "sweetalert2";
import * as fromRootStore from "../../../reducers";
import { FinyearService, SeasonService } from "../../../services/index";

@Component({
  selector: "addEditInvoice",
  templateUrl: "./addEditSeason.component.html",
})
export class AddEditSeasonComponent implements OnInit {
  @Output() tabUpdateEvent = new EventEmitter();
  tabTitle: string;
  tabID: string;
  mode: string;
  saveEvent : any;
  isLoadMask: Promise<any>;
  @Input() partydata: any = {};
  @Input() _params: any;
  @Input() set params(val: any[]) {
    this._params = val;
    this.mode = val["mode"];
    // this.sale_type = val["sale_type"];
    // this.upd_type = val["upd_type"];
    this.saveEvent = val["data"].tabevent;
    let partyData = Object.assign({}, val["data"]);
    // this.invoicedata = invoicedata;
    // console.log(this.mode, this.upd_type);
    // if (this.mode == "Convert") {
    //   this.invoicedata.mode = "Add";
    // }

    // if (this.mode == "Convert") {
    //   //  this.editInvoiceList();
    //   this.invoicedata.dcdt = this.datePipe.transform(new Date(), "yyyy-MM-dd");
    //   //   this.oncheck(this.invoicedata.salesorder);
    // }
    // if (this.mode == "View" || this.mode == "Edit") {

    //   console.log(this.invoicedata, this.upd_type);
    //   //    this.invoicedata.dcdt = this.datePipe.transform(new Date(), 'yyyy-MM-dd');
    // }
  }


  dataList: any = [];
  agentList: any = [];
  finyearList: any = [];
  get params(): any[] {
    return this._params;
  }
  isLoading: boolean = false;
  @ViewChild("partyForm") partyForm;
  orderfromdtControl: FormControl = new FormControl();
  ordertodtControl: FormControl = new FormControl();
  salesfromdtControl: FormControl = new FormControl();
  salestodtControl: FormControl = new FormControl();
  partyCtrl: FormControl = new FormControl();

  constructor(
    public store: Store<fromRootStore.State>,
    private seasonService: SeasonService,
    private finyearService: FinyearService,

    public toasterService: ToasterService,
    public datePipe: DatePipe
  ) { }

  ngOnInit() { }

  ngAfterViewInit() {
    setTimeout(() => {
      $("#partyname").focus();
      this.loadFinyearList();
    }, 100);
  }
  loadFinyearList() {
    let that = this;
    that.finyearService.getFinYearList({}).then((res: any) => {
      that.finyearList = res.data;

      this.partyCtrl.setValue(this.partydata["fin_id"]);
    });
  }

  displayFn(comboType: string, id: number) {
    let list: any = [];
    let that = this;
    if (comboType == "FinYear") {
      list = this.finyearList;
    }

    if (id && list.length > 0) {
      let fitem = _.find(list, { fin_id: id });
      return fitem["finyear"];
    }
    return "";
  }

  onEnterKeyPressed(nextEl: string) {
    if ($(".swal2-container").length > 0) {
      return false;
    }
    if (nextEl == "partySave" && this.partyForm.valid) {
      this.onSaveSeason();
    } else {
      $("#" + nextEl).focus();
    }
  }
  addSeason() {
    this.partydata.order_from = this.datePipe.transform(
      this.partydata.order_from,
      "yyyy-MM-dd"
    );
    this.partydata.order_to = this.datePipe.transform(
      this.partydata.order_to,
      "yyyy-MM-dd"
    );
    this.partydata.sales_from = this.datePipe.transform(
      this.partydata.sales_from,
      "yyyy-MM-dd"
    );
    this.partydata.sales_to = this.datePipe.transform(
      this.partydata.sales_to,
      "yyyy-MM-dd"
    );
    let row = Object.assign({}, this.partydata);

    if (this.dataList.length > 0) {
      let obj = this.dataList.find(e => (e.season == this.partydata.season) || (e.order_from == this.partydata.order_from) || e.order_to == this.partydata.order_to || e.sales_from == this.partydata.sales_from || e.sales_to == this.partydata.sales_to)
      if (obj) {
        console.log(obj)
        swal("Season Name Or Date Already Exist...!")
        return
      }
    }

    this.dataList.push(row);
    this.partydata.season = '';
    this.partydata.order_from = '';
    this.partydata.order_to = '';
    this.partydata.sales_from = '';
    this.partydata.sales_to = '';
  }
  // editrow(i){
  //   console.log(i)
  // }
  onSaveSeason(): void {
    let that = this;

    that.dataList.forEach(e => {
      e.order_from = that.datePipe.transform(new Date(e["order_from"]), "yyyy-MM-dd");
      e.order_to = that.datePipe.transform(new Date(e["order_to"]), "yyyy-MM-dd");
      e.sales_from = that.datePipe.transform(new Date(e["sales_from"]), "yyyy-MM-dd");
      e.sales_to = that.datePipe.transform(new Date(e["sales_to"]), "yyyy-MM-dd");
    });

    let params = { data: JSON.stringify(that.dataList) };

    swal({
      title: "Are you sure to save this Details?",
      type: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, save it!",
      cancelButtonText: "No, want to change",
    }).then(function () {
      that.isLoadMask = that.seasonService
        .addUpdateSeason(params)
        .then(function (res: any) {
          // that.isLoading = false;
          if (res.success) {
            that.partydata = {
              season: "",
              fin_id: "",
              order_from: "",
              order_to: "",
              sales_from: "",
              sales_to: "",
            };
            that.dataList = [];
            if (that.saveEvent) {
              that.saveEvent.emit();
            }
            that.toasterService.pop({
              bodyOutputType: 1,
              type: "success",
              title: "SUCCESS",
              body: res.message,
            });

            let tabObj = {
              action: "CloseTab",
              params: {},
            };

            // that.bsModalRef.hide();
            that.tabUpdateEvent.emit(tabObj);
          } else {
            swal("ERROR", res.message, "error");
          }
        })
        .catch(function (error: any) {
          // that.isLoading = false;
          let res = JSON.parse(error._body);
          swal("ERROR", res.message, "error");
          //console.log(error);
        });
    });
  }
}



// WEBPACK FOOTER //
// /Users/afsarahamed/Documents/symatis/projects/hyatt-angularweb/src/app/components/master/Season/addEditSeason.component.ts